// extracted by mini-css-extract-plugin
export var growableInput = "_72-0";
export var tagContainer = "_72-2";
export var textInput = "_72-1";